<template>
    <article class="identity-role-card" :data-role-card="role.key">
        <div class="identity-role-art" aria-hidden="true">
            <img class="identity-role-portrait" :src="role.portrait" alt="" />
        </div>
        <div class="identity-role-content">
            <div class="identity-role-topline">
                <h3>{{ role.professionalTypeDescription }}</h3>
                <span class="identity-status-badge" :class="{ review: role.statusTagType === 'warning' }">{{ role.currentStatusDescription }}</span>
            </div>
            <p class="identity-role-description">{{ role.statusDescription }}</p>
            <p v-if="!role.applicationHistory.length" class="identity-role-detail">暂无申请记录</p>
            <p
                v-for="application in role.applicationHistory"
                :key="application.id || `${application.submittedAt}-${application.applicationType}`"
                class="identity-role-detail">
                <strong>{{ application.applicationTypeDescription }} · {{ application.applicationStatusDescription }}</strong>
                <span v-if="application.submittedAt">提交：{{ application.submittedAt }}</span>
                <span v-if="application.finishedAt">完成：{{ application.finishedAt }}</span>
            </p>
        </div>
    </article>
</template>

<script>
export default {
    name: "IdentityRoleCard",
    props: {
        role: {
            type: Object,
            required: true,
        },
    },
    computed: {
    },
};
</script>

<style scoped>
.identity-role-card {
    position: relative;
    display: grid;
    grid-template-columns: 128px minmax(0, 1fr);
    gap: 22px;
    min-height: 272px;
    padding: 20px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #efd9dc;
    border-radius: 24px;
    box-shadow: 0 14px 30px rgba(98, 62, 106, .07);
}

.identity-role-card::before {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 6px;
    content: "";
    background: #8fd6fa;
}

.identity-role-card[data-role-card="makeup"]::before {
    background: #ffa3b8;
}

.identity-role-art {
    height: 230px;
    min-height: 230px;
    overflow: hidden;
    background: #f6f3ff;
    border-radius: 14px;
}

.identity-role-portrait {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

.identity-role-content {
    display: flex;
    min-width: 0;
    flex-direction: column;
    align-items: flex-start;
}

.identity-role-topline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 12px;
}

.identity-role-topline h3 {
    margin: 0;
    color: #3f3158;
    font-size: 24px;
    font-weight: 800;
    letter-spacing: -.02em;
}

.identity-status-badge {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    min-height: 26px;
    padding: 3px 9px;
    color: #725d8d;
    background: #f0eaff;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
}

.identity-status-badge.review {
    color: #916022;
    background: #fff1c9;
}

.identity-role-description {
    min-height: 42px;
    margin: 14px 0 8px;
    color: #746c7e;
    font-size: 13px;
    line-height: 1.65;
}

.identity-role-detail {
    min-height: 40px;
    margin: 0 0 18px;
    color: #857f76;
    font-size: 12px;
    line-height: 1.65;
}

.identity-role-detail.review-copy {
    color: #a66f26;
}

.identity-role-action {
    width: 100%;
    min-height: 42px;
    margin-top: auto;
    padding: 9px 14px;
    color: #674088;
    background: transparent;
    border: 1px solid #d6b9e8;
    border-radius: 12px;
    cursor: pointer;
    font: inherit;
    font-size: 13px;
    font-weight: 800;
    transition: background-color 180ms ease, border-color 180ms ease, color 180ms ease;
}

.identity-role-action:hover {
    color: #fff;
    background: #ed648c;
    border-color: #ed648c;
}

.identity-role-action.review {
    color: #7d5a23;
    border-color: #dec79e;
}

.identity-role-action.review:hover {
    color: #4e3818;
    background: #f3e6ca;
    border-color: #d9b983;
}

@media (max-width: 1250px) {
    .identity-role-card {
        grid-template-columns: 110px minmax(0, 1fr);
    }

    .identity-role-art {
        height: 220px;
        min-height: 220px;
    }
}
</style>
